// src/components/Header.js
import React from "react";
import styles from './Header.module.css';
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from '../AuthContext';
import logoUrl from "../assets/logo.png";

const menuItems = [
  { label: "Recherche", href: "/recherche" },
  { label: "Signes et Abréviations", href: "/signesabreviations" },
  { label: "Éléments de Grammaire", href: "/elementsdegrammaire" },
  { label: "Brève Histoire du Rwanda", href: "/brevehistoire" },
];

function Header() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      console.error('Erreur lors de la déconnexion : ', error);
    }
  };

  return (
    <nav className={styles.nav}>
      <Link to="/">
        <img className={styles.menuLogo} alt="logo" src={logoUrl} />
      </Link>
      <ul className={styles.menu}>
        {user ? (
          // -- Menu si l'utilisateur est CONNECTÉ --
          <>
            {menuItems.map((item, index) => (
              <li key={index}><Link to={item.href}>{item.label}</Link></li>
            ))}
            <li>
              <button onClick={handleSignOut} className={styles.connectButton}>
                Se déconnecter
              </button>
            </li>
          </>
        ) : (
          // -- Menu si l'utilisateur est DÉCONNECTÉ --
          <li>
            <Link to="/connexion" className={styles.connectButton}>
              Se connecter
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Header;